import { rankingItems } from '@/mocks/home';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  stable: 'ri-subtract-line text-foreground-400',
  down: 'ri-arrow-down-line text-secondary-500',
};

function RankBadge({ rank }: { rank: number }) {
  if (rank === 1) return <span className="w-7 h-7 rounded-md bg-accent-500 text-background-50 flex items-center justify-center text-sm font-black font-heading">1</span>;
  if (rank === 2) return <span className="w-7 h-7 rounded-md bg-foreground-300 text-background-50 flex items-center justify-center text-sm font-black font-heading">2</span>;
  if (rank === 3) return <span className="w-7 h-7 rounded-md bg-primary-400 text-background-50 flex items-center justify-center text-sm font-black font-heading">3</span>;
  return <span className="w-7 h-7 rounded-md bg-background-200 text-foreground-500 flex items-center justify-center text-sm font-semibold">{rank}</span>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            全网热播电视剧实时热度排行
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={item.rank}
              href="#hero"
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer no-underline hover:bg-background-100 transition-colors ${
                idx < rankingItems.length - 1 ? 'border-b border-background-100' : ''
              }`}
            >
              <RankBadge rank={item.rank} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="flex-shrink-0 px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[10px] font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm font-black text-accent-500 font-heading">{item.heat}</span>
                <i className={`text-sm ${trendIcon[item.trend] || trendIcon.stable}`}></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}